module.exports = __webpack_public_path__ + "static/gence340-686d9bd668d570d6ce5cf539ea9b50bc.jpg";